
import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

class PieChart extends Component {
  state = {
    animationDuration: 2000, // Default duration
    easingType: 'easeOutExpo' // Default easing
  };

  render() {
    const { series, categories } = this.props;
    const { animationDuration, easingType } = this.state;
    const baseColor = '#217ca3'; // Base color for variations
    const colors = Highcharts.map(Highcharts.getOptions().colors, () => {
      return Highcharts.color(baseColor).brighten((Math.random() - 1) / 5).get();
    });

    const options = {
      chart: {
        backgroundColor: 'rgba(0,0,0,0)',
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        height: "50%",
        animation: {
          duration: animationDuration,
          easing: easingType
        }
      },
      credits: {
        enabled: false
      },
      title: false,
      tooltip: {
        pointFormat: '<b>{point.category}</b>: <b>{point.percentage:.1f}%</b>',
        formatter: function () {
          const categoryName = categories[this.point.x];
          const percentage = Highcharts.numberFormat(this.point.percentage, 1);
          return `<b>${categoryName}</b>: <b>${percentage}%</b>`;
        }
      },
      accessibility: {
        point: {
          valueSuffix: '%'
        }
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          colors,
          depth: 35,
          dataLabels: {
            enabled: true,
            connector: {
              enabled: true, // Enable connectors
              type: 'arrow', // Arrow type connector
              width: 10, // Connector width
              color: '#000000' // Color of the connector
            },
            formatter: function () {
              const categoryName = categories[this.point.x]; // Get category name
              const percentage = Highcharts.numberFormat(this.point.percentage, 1); // Format percentage
              return `${percentage}%`; // Return label with category and percentage
            },
            distance: -50, // Position the label closer to the pie
            filter: {
              property: 'percentage',
              operator: '>',
              value: 4 // Show labels for slices greater than 4%
            }
          }
        }
      },
      series: [
        {
          type: 'pie',
          data: series,
          animation: {
            duration: animationDuration,
            easing: easingType
          }
        }
      ]
    };

    return (
      <div>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    );
  }
}

export default PieChart;
